import AllEmployeePayslips from "../../../../components/company/pay-slip/employee-payslips";

export default function AllEmployeePayslipsPage(){
  return <AllEmployeePayslips />
}